import { Http, Headers, URLSearchParams } from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { environment } from "../../environments/environment";
import { AppService } from "../app.service";
var HistoryService = (function () {
    function HistoryService(http, appService) {
        this.http = http;
        this.appService = appService;
        this.apiUrl = environment.apiUrl;
        this.jwt = appService.getJwt();
    }
    HistoryService.prototype.getHistoryList = function (filterParams) {
        var url = this.apiUrl + 'api/cms/history/list';
        var headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        var params = new URLSearchParams();
        params.append("page", filterParams.page);
        params.append("size", filterParams.size);
        var body = JSON.stringify({});
        return this.http.post(url, body, { headers: headers, params: params })
            .toPromise()
            .then(function (res) { return res.json(); })
            .then(function (resJson) { return resJson; });
    };
    return HistoryService;
}());
export { HistoryService };



// WEBPACK FOOTER //
// /build/client-cms/src/app/history/history.service.ts.pre-build-optimizer.js